/* eslint-disable react-hooks/exhaustive-deps */
import { Select } from 'antd';
import React, { useEffect, useMemo } from 'react';
import AjaxSelect from '../../../../../components/DynamicFormNew/components/ajaxSelect';

const CustomAjaxSelect = ({
  data = {},
  showIf = false,
  updateData = () => { },
  k = '',
  v = {},
  areYouSureState = false,
}) => {
  useEffect(() => {
    if (!showIf && data[k]) {
      updateData(k, undefined);
    }
  }, [showIf]);

  const isDisabled = useMemo(() => {
    if (areYouSureState) {
      return true;
    }
    return false;
  }, [areYouSureState]);

  return (
    <div>
      {(showIf) ? (
        <AjaxSelect
          onChange={(val) => updateData(k, val)}
          allowClear
          inputName={k}
          call={v.call}
          value={data[k]}
          formsValue={data}
          mainForm={{ getFieldsValue: () => data, }}
          props={{ style: { width: '100%' }, disabled: isDisabled }}
        />
      ) : (
        <Select
          disabled={true}
          style={{ width: '100%' }}
        />
      )}
    </div>
  );
};

export default CustomAjaxSelect;
